/*
 * ******************************************************************
 * Copyright (c) 2022-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Component, Input } from "@angular/core";
import { NavItem } from "./nav-item.model";

// @formatter:off
@Component({
    standalone: false,
    selector: "console-vertical-nav",
    templateUrl: "./vertical-nav.component.html",
    styleUrls: ["./vertical-nav.component.scss"]
})
// @formatter:on
export class VerticalNavComponent {
    @Input() navItems: NavItem[];

    public VERTICAL_NAV_AUTO_COLLAPSE_WIDTH = 680;
    public collapsed: boolean = false;
}
